import React, { useContext } from "react";
import { QuizContext } from "../../App";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import ButtonCancelAndGoToPrevPage from "./ButtonCancelAndGoToPrevPage";
import leaveTeam from "../../reducer/actions/groupActions/LeaveTeam";
import ModalForLeaveTeam from "../modals/ModalForLeaveTeam";

const ButtonsLeaveTeam = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <>
      {quizContext.state.teamQuizzes.filter(el => el.author_id === quizContext.state.currentUser.id).length !== 0
        ? <span>Если Вы хотите уйти из команды, сначала удалите из списка квизов команды все свои квизы.</span>
        : <Container fluid='md'>
          <Link
            to={`/user/${quizContext.state.currentUser.id}`}
            style={{ textDecoration: 'none' }}
          >
            <button
              className={`${theme}-sec-btn`}
              onClick={(e) => {
                e.preventDefault()
                leaveTeam(
                  quizContext.dispatch,
                  quizContext.state
                )
                quizContext.dispatch({
                  type: "leaveTeam"
                })
              }}
            >
              УЙТИ ИЗ КОМАНДЫ
            </button>
          </Link>

          <ButtonCancelAndGoToPrevPage />

        </Container>
      }

      {quizContext.state.alertStatus === "left team"
        && <ModalForLeaveTeam />
      }
    </>
  )
}

export default ButtonsLeaveTeam